import script from "./CartPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPage.vue?vue&type=script&setup=true&lang=js"

import "./CartPage.vue?vue&type=style&index=0&id=25820bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25820bf2"]])

export default __exports__